import { unescapeCustomString } from './escape-string-for-context'

export function unicodeToBase64 (str) {
  const utf8Bytes = new TextEncoder().encode(unescapeCustomString(str))

  const binaryString = String.fromCharCode(...utf8Bytes)

  return btoa(binaryString)
}
